import { useContext } from "react";
import { ThemeValues } from "../ThemeUsage/theme";
import { ThemeContext } from "../ThemeUsage/ThemeUsage";
import { LichtBlickLogo, LichtBlickLogoSMA } from "src/assets";

const TariffProviderIcon = () => {
  const themeName = useContext(ThemeContext);
  const getLogo = () => {
    switch (themeName) {
      case ThemeValues.default:
        return <LichtBlickLogo />;
      case ThemeValues.SMA:
        return <LichtBlickLogoSMA />;
      case ThemeValues.lichtblick:
        return <LichtBlickLogoSMA />;
      default:
        return <LichtBlickLogo />;
    }
  };
  return <>{getLogo()}</>;
};

export default TariffProviderIcon;
